import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class Message extends JSONMapped() {
	@jsonProperty()
	severity: MessageType;

	@jsonProperty()
	text: string;

	constructor(data?: Partial<Message>) {
		super();
		Object.assign(this, data);
	}

	static warning(text: string) { return new Message({severity: MessageType.Warning, text}); }
	static alert(text: string) { return new Message({severity: MessageType.Alert, text}); }
	static info(text: string) { return new Message({severity: MessageType.Info, text}); }
	static success(text: string) { return new Message({severity: MessageType.Success, text}); }

	equals(otherMessage: Message): boolean {
		return (otherMessage.severity === this.severity && otherMessage.text === this.text);
	}
}

export enum MessageType {
	Warning = "Warning",
	Alert = "Alert",
	Info = "Info",
	Success = "Success",
}
